import React, { useContext } from 'react';

import { QueryStringContext } from 'contexts/QueryStringContext';
import { GroupSelect } from 'components/NavFilter';
import { TAXONOMY_TYPES } from '../utils';

const TAXONOMY_DATA = [
	{
		name: 'directTaxonomy',
		label: 'Direct spend',
		options: [
			{ label: 'Project taxonomy', value: TAXONOMY_TYPES.PROJECT },
			{
				label: 'Client taxonomy',
				value: TAXONOMY_TYPES.CLIENT,
			},
		],
	},
	{
		name: 'indirectTaxonomy',
		label: 'Indirect spend',
		options: [
			{ label: 'Project taxonomy', value: TAXONOMY_TYPES.PROJECT },
			{
				label: 'AP taxonomy',
				value: TAXONOMY_TYPES.AP,
			},
			{
				label: 'Client taxonomy',
				value: TAXONOMY_TYPES.CLIENT,
			},
		],
	},
];

export const TaxonomySelect = () => {
	const {
		indirectTaxonomy,
		directTaxonomy,
		setQueryStringStateAndPush,
		spendType,
	} = useContext(QueryStringContext);
	const onTaxonomyChange = updates => {
		setQueryStringStateAndPush(updates);
	};

	return (
		<GroupSelect
			name="Taxonomies"
			data={TAXONOMY_DATA}
			selected={{
				indirectTaxonomy,
				directTaxonomy,
			}}
			type={spendType}
			onChange={onTaxonomyChange}
		/>
	);
};
